import React from "react";
import { Button, Form, FormGroup, Label, Input, FormText , Col, Row, Alert } from 'reactstrap';
import Chatx from '../chat/chat'
import Uploader from '../upload/upload'
import Attachments from '../upload/alluploads'

import NotificationAlert from "react-notification-alert";
import ModalForm from '../modal/modal'

import AuthService from "services/auth.service";

import Timestamp from "react-timestamp";

import Loader from "react-loader-spinner";
import { event } from "jquery";

class Tform extends React.Component {



  constructor(props) {
    super(props);

    const Currentuser = AuthService.getCurrentUser();


        const UserRoles = Currentuser.roles;



    this.state = {
        queue:"HelpDesk",
        category:"Email",
        sub:"Test",
        agent:"test.agent",
        client:"test.user",
        department:"Test Department",
        state:"Open",
        created:"2022-02-26T08:04:28.000Z",
        updated:"2022-02-26T08:04:28.000Z",
        slares:"Achieved",
        sapreqnum:"None",
        descr:'Here is Ticket ticket main description ',
        author:"Test End User",
        prmqueue:'HelpDesk',
        qusers:[
          {
              "refname": "test.agent"
          },

      ],
        oldstates:{queue:'HelpDesk',
          agent:"test.agent",
          state:"Open",
          category:"Email",
          sub:"Test" },
        loading:false,
        LogsOpen:false,
        AttachOpen:false,
        formcatgs:[
          {
              "refsub": "Printer"
          },
          {
              "refsub": "Computer"
          },
          {
              "refsub": "iP-Phone"
          },
          {
              "refsub": "Office"
          },
          {
              "refsub": "Email"
          },
          {
              "refsub": "File"
          },
          {
              "refsub": "Applications"
          },
          {
              "refsub": "Network"
          },
          {
              "refsub": "iP-Cam"
          },
          {
              "refsub": "Purchase Request"
          },
          {
              "refsub": "SAP Reservation"
          },
          {
              "refsub": "Asset Management"
          },
          {
              "refsub": "Configuration Backup"
          },
          {
              "refsub": "Other"
          }
      ],
      formsubcats:[
        {
            "refname": "Test"
        },

    ],
    Logs:[
      {
          "id": 8470,
          "tktid": 22515,
          "agent": "test.agent",
          "ipadd": "50.50.50.13",
          "action": "Set Resolution",
          "prevstate": "",
          "curstate": "Resolution Added",
          "logmsg": "User test.agent Added a Resolution For The Ticket ",
          "createdAt": "2022-02-27T07:11:33.000Z",
          "updatedAt": "2022-02-27T07:11:33.000Z"
      },
      {
          "id": 8471,
          "tktid": 22515,
          "agent": "test.agent",
          "ipadd": "50.50.50.13",
          "action": "Change Assignee",
          "prevstate": "Non-Assigned",
          "curstate": "test.agent",
          "logmsg": "Agent test.agent Has Assigned The Ticket To Himself",
          "createdAt": "2022-02-27T07:11:39.000Z",
          "updatedAt": "2022-02-27T07:11:39.000Z"
      },
      {
          "id": 8472,
          "tktid": 22515,
          "agent": "test.agent",
          "ipadd": "50.50.50.13",
          "action": "Change State",
          "prevstate": "Open",
          "curstate": "Waiting For User",
          "logmsg": "Ticket State Has Been Changed From \"Open\" To \"Waiting For User\" By  test.agent",
          "createdAt": "2022-02-27T07:11:39.000Z",
          "updatedAt": "2022-02-27T07:11:39.000Z"
      }
  ],
          isAgent:true,
        resoexist:true


    };
     


    //remove to generalize
  }



  notify = (typee , msg) => {
    var options = {};
    options = {place: 'tc',message: (<div><div> {msg}</div></div>  ),type: typee,icon: "now-ui-icons ui-1_bell-53",autoDismiss: 7,}
    this.refs.notificationAlert.notificationAlert(options);
  }
  






















  






  

componentDidMount() {


  

}

componentWillUnmount(){

  clearInterval(this.interval);

  
}






resadded = () =>{

  this.setState( {
    resoexist:true,
});


} 








handleSubmit = (e) =>{
  e.preventDefault();

  let loguser = AuthService.getCurrentUser().username;

  let data = {    tktid:this.props.tktid,
    agent:loguser,
    action: 'No Action',
     prevstate:'',
     curstate:'',
     logmsg:``
  };
  



  
if (this.state.oldstates.queue !== this.state.queue) {
  
data.action = 'Change Queue'

}
 else if (this.state.oldstates.agent !== this.state.agent) {
  
  data.action = 'Change Assignee'
  
  }  else if (this.state.oldstates.state !== this.state.state) {
  
    data.action = 'Change State'

    }  else if (this.state.oldstates.category !== this.state.category) {
  
      data.action = 'Change Category'
    
      }  else if (this.state.oldstates.sub !== this.state.sub) {
  
        data.action = 'Change Sub-Category'
  

        }



        
      


  if (this.state.state === 'Completed' && !this.state.resoexist) {this.notify( 'danger' , 'You Must Mark Single Note as Resolution')}



 else if (data.action === 'No Action') {this.notify( 'danger' , 'No Changes Were Made!')}


  else  {

  //if (this.state.category.length < 1  || this.state.sub.length < 1   ) {this.notify( 'danger' , 'Category and Sub-Category Fileds Are Required')}


   this.notify('info' , 'Ticket Has Been Updated');
  

}






}

















LogsOpen = () => this.setState({ LogsOpen: true });
closeLogs = () => {this.setState({ LogsOpen: false ,targetid:''})}

AttachOpen = () => this.setState({ AttachOpen: true });
closeAttach = () => {this.setState({ AttachOpen: false})}



handleChange = (e) =>{ 
  

  let myPromise = new Promise((myResolve, myReject) =>{ 
  
  // The producing code (this may take some time)
  this.setState({[e.target.name]: e.target.value})

  



      myResolve(e.target.name);
      myReject("Error");
    



  });
  
  myPromise.then(
    (value)  =>{
      if (value === 'queue') {this.setState({category: "",sub: "" , agent:"Non-Assigned" });    
     
    }

if (value === 'category') {this.setState({sub: ""});}
    },
    (error)  =>{console.log(error);}


  );
  
  
  

//handleChange = (e) =>{ this.setState({[e.target.name]: e.target.value})


}

  render(){
    const categories = this.state.formcatgs.map(cat =><option key={cat.refsub}>{cat.refsub}</option>
      )


      const subcats = this.state.formsubcats.map(cat =><option key={cat.refname}>{cat.refname}</option>
        )

        const qusrs = this.state.qusers.map(user =><option key={user.refname}>{user.refname}</option>
          )



          const logs =this.state.Logs.map(log =><p key={log.id}><strong><Timestamp date={log.createdAt} />: </strong> {log.logmsg}</p>
            )

            

            let alllogs = <div><strong> <Timestamp date={this.state.created} /></strong><p>User {this.state.author} Has Created The Ticket</p>
            
            {logs}
            
            </div>;



let attachmentcontent = <div><Uploader tktid={this.props.tktid} submitexist/><br/><hr /><Attachments tktid={this.props.tktid} /></div>

    return(
<div>
<NotificationAlert ref="notificationAlert" />


{ this.state.loading ? 
  <Row className="justify-content-center align-items-center" >

<Loader
        type="Puff"
        color="rgb(101, 153, 57)"
        height={100}
        width={100}
        timeout={5000} //3 secs
      /></Row>
:


<Form onSubmit={e => { e.preventDefault(); }}>


{ this.state.LogsOpen ? 
          <ModalForm 
            closeModal={this.closeLogs} 
            isOpen={this.state.LogsOpen} 
            title={"Action Logs"}
            hoste={alllogs}
            size="md"
          /> 
          : 
          null 
        }


        { this.state.AttachOpen ? 
          <ModalForm 
            closeModal={this.closeAttach} 
            isOpen={this.state.AttachOpen} 
            title={"Attachments"}
            hoste={attachmentcontent}
            size="md"
          /> 
          : 
          null 
        }






      <FormGroup>
        <Row>


        <Col xs={12} md={4}>
<Label for="exampleSelect"><strong>Client</strong></Label>
<Input type="select" name="client" id="categasdao" onChange={this.handleChange} value={this.state.client} >

<option>{this.state.client}</option>

</Input>
</Col>


<Col xs={12} md={4}>
          <Label for="exampleSelect"><strong>Category</strong></Label>
          <Input type="select" name="category" id="catego" onChange={this.handleChange} value={this.state.category} required>

          <option></option>
          {categories}      

          </Input>
          </Col>

          <Col xs={12} md={4}>
          <Label for="exampleSelect"><strong>Sub-Category</strong></Label>
          <Input type="select" name="sub" id="sub" onChange={this.handleChange}  value={this.state.sub} required>
          <option></option>
          {subcats}            
          </Input>
          </Col>
          </Row>
          <br />
        <Row>
        <Col xs={12} md={4}>          <Label for="exampleSelect"><strong>Queue</strong></Label>
          <Input type="select" name="queue" id="exampleSelect" onChange={this.handleChange}  value={this.state.queue}>
            <option>HelpDesk</option>
            <option>Systems</option>
            <option>Network</option>
            <option>SAP</option>
          </Input>
          </Col>

          <Col xs={12} md={4}>          <Label for="exampleSelect"><strong>Assigned To</strong></Label>
          <Input type="select" name="agent" id="agent" onChange={this.handleChange}  value={this.state.agent}>
          <option></option>
            {qusrs}
          </Input>
          </Col>
          <Col xs={12} md={4}>
          <Label for="exampleSelect"><strong>Status</strong></Label>
          <Input type="select" name="state" id="sttate" onChange={this.handleChange}  value={this.state.state}>
          <option>Open</option>
          <option>In Progress</option>
          <option>Pending</option>
          <option>Waiting For User</option>
          <option>Completed</option>
          <option>Canceled</option>

          <option>Closed</option>

          </Input>
          </Col>


</Row>









        </FormGroup>

<FormGroup>

<Row>

<Col xs={12} md={6}>

  <strong >Last Update: </strong>

  <Timestamp  date={this.state.updated} /> <span> </span>
  <br/>
  <strong >Response SLA: </strong>
{this.state.slares}
<br/>
<strong >Department: </strong>
{this.state.department}

{this.state.queue === 'SAP' ? 

<span>
<br/>
<strong >Request#: </strong>

 <span>{this.state.sapreqnum}</span>






</span>

:null


}

  </Col>



<Col xs={12} md={6}>
<Button variant="contained" type="button" onClick={this.handleSubmit} style={{backgroundColor:'rgb(130, 190, 80)'}} className="pull-right">
              Submit
          </Button>


          <Button variant="contained"  type="button" onClick={this.AttachOpen} className="pull-right" >
              Attachments
          </Button>

          <Button variant="contained" type="button" onClick={this.LogsOpen} className="pull-right">
              Action Logs
          </Button>


          </Col>









  </Row>




</FormGroup>



<FormGroup>
        

        <Label for="exampleText"><strong>Description</strong></Label>
   <Input type="textarea" name="descddfr" id="tktsss"  onChange={this.handleChange}  value={this.state.descr} />

   </FormGroup>




<FormGroup>
<strong>Case Notes</strong>
          <Chatx tktid={this.props.tktid} setres={this.resadded} />
</FormGroup>
</Form>

}





</div>
    )
  }
}



export default Tform;